(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AccountCardAlt", [], factory);
	else if(typeof exports === 'object')
		exports["AccountCardAlt"] = factory();
	else
		root["AccountCardAlt"] = factory();
})(this, function() {
return 